import { Image, Page as ReactPDFPage, StyleSheet, View } from '@react-pdf/renderer';

import logo from '../../../assets/logos/appraisify/appraisify-colored.png';
import { Text } from '../Text/Text.tsx';
import { sharedStyles } from '../sharedStyles.ts';

const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  logo: {
    height: 20,
    minHeight: 20,
    maxHeight: 20,
    width: 60,
    minWidth: 60,
    maxWidth: 60,
    marginBottom: 12,
  },
  title: {
    marginBottom: 12,
  },
});

type Props = { title?: string; children: React.ReactNode };

export const Page = ({ children, title }: Props) => (
  <ReactPDFPage style={styles.page} size="A4" wrap>
    <Image style={styles.logo} src={logo} />
    {title && (
      <View style={[styles.title, sharedStyles.fullWidth]}>
        <Text variant="h2">{title}</Text>
      </View>
    )}

    {children}
  </ReactPDFPage>
);
